var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.iconType == 'b-icon')?_c('b-icon',{attrs:{"icon":_vm.iconValue}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }